import axios from "axios";
import localStorageService from "app/services/localStorageService";

export const GetEscola = () => {
  return new Promise((resolve) => {
    const $auth = localStorageService.getItem("auth_user");

    const $url = `/api/escola/getescola/${$auth.idEscola}`;

    axios.get($url).then(function (data) {
      resolve(data);
    });
  });
};